import { useDeleteEventRecordingTranscribeMutation } from '@crew/apis/eventRecordingTranscribe/eventRecordingTranscribeApis'
import { EventRecordingTranscribe } from '@crew/models/domain'
import { NotifyEventType } from 'enums/app'
import {
  ObjectEventMessage,
  notifyEventRecordingTranscribeEvent,
} from 'features/app/states/appSlice'
import { useCallback } from 'react'
import { useAppDispatch } from 'states/hooks'

export const useEventRecordingTranscribeItem = () => {
  const dispatch = useAppDispatch()

  const [
    deleteEventRecordingTranscribeMutation,
    { isLoading: isLoadingDeleteTranscribe },
  ] = useDeleteEventRecordingTranscribeMutation()

  const deleteEventRecordingTranscribe = useCallback(
    async (eventRecordingTranscribeId: string, version: number) => {
      // イベント録画文字起こし削除APIリクエスト
      await deleteEventRecordingTranscribeMutation({
        eventRecordingTranscribeId,
        version,
      }).unwrap()

      const objectEventMessage: ObjectEventMessage<EventRecordingTranscribe> = {
        eventType: NotifyEventType.Deleted,
        id: eventRecordingTranscribeId as string,
        object: undefined,
      }

      dispatch(notifyEventRecordingTranscribeEvent(objectEventMessage))
    },
    [deleteEventRecordingTranscribeMutation, dispatch]
  )

  return {
    deleteEventRecordingTranscribe,
    isLoadingDeleteTranscribe,
  }
}
